import Vue from 'vue'
import defaultState from './state'

export default {
  initStore(state) {
    Object.assign(state, defaultState)
  },
  initModal(state) {
    Vue.set(state, 'modalId', null)
    Object.assign(state.modal, defaultState.modal)
  },
  setActiveTab(state, activeTab) {
    Vue.set(state, 'activeTab', activeTab)
  },
  setKw(state, kw) {
    Vue.set(state, 'kw', kw)
  },
  setCurrentStatus(state, currentStatus) {
    Vue.set(state, 'currentStatus', currentStatus)
  },
  setTask(state, task) {
    Vue.set(state, 'task', task)
  },
  setRule(state, rule) {
    Vue.set(state, 'rule', rule)
  },
  setSort(state, sort) {
    Vue.set(state, 'sort', sort)
  },
  setSortStatus(state, status) {
    Vue.set(state, 'sortStatus', status) /* status 可能為'asc' or 'desc' */
  },
  setReserveTotal(state, reserveTotal) {
    Vue.set(state, 'reserveTotal', reserveTotal)
  },
  //line預約單的數量
  setLineReserveTotal(state, lineReserveTotal) {
    Vue.set(state, 'lineReserveTotal', lineReserveTotal)
  },
  //顯示最近訂單的數量
  setRecentTotal(state, recentTotal) {
    Vue.set(state, 'recentTotal', recentTotal)
  },
  //未配對訂單數量
  //setNonAssignTotal(state, nonAssignTotal) {
  //  Vue.set(state, 'nonAssignTotal', nonAssignTotal)
  //},
  setNonmatchTotal(state, nonmatchTotal) {
    Vue.set(state, 'nonmatchTotal', nonmatchTotal)
  },
  //預約時間1小時內訂單數量
  setReserveTotal(state, reserveTotal) {
    Vue.set(state, 'reserveTotal', reserveTotal)
  },
  //setNonReplyTotal(state, nonReplyTotal) {
  //  Vue.set(state, 'nonReplyTotal', nonReplyTotal)
  //},
  setLastUpdatedTime(state, lastUpdatedTime) {
    Vue.set(state, 'lastUpdatedTime', lastUpdatedTime)
  },
  /* 車隊專屬 */
  setTeamList(state, list) {
    Vue.set(state, 'teamList', list)
  },
  setTeamPagingCurrentPage(state, currentPage) {
    Vue.set(state.teamPaging, 'currentPage', currentPage)
  },
  setTeamPagingNpp(state, npp) {
    Vue.set(state.teamPaging, 'npp', npp)
  },
  setTeamPagingTotalEntries(state, totalEntries) {
    Vue.set(state.teamPaging, 'totalEntries', totalEntries)
  },
  setTeamPagingTotalPages(state, totalPages) {
    Vue.set(state.teamPaging, 'totalPages', totalPages)
  },
  /* line網路預約 */
  setLineList(state, list) {
    Vue.set(state, 'lineList', list)
  },
  setLinePagingCurrentPage(state, currentPage) {
    Vue.set(state.linePaging, 'currentPage', currentPage)
  },
  setLinePagingNpp(state, npp) {
    Vue.set(state.linePaging, 'npp', npp)
  },
  setLinePagingTotalEntries(state, totalEntries) {
    Vue.set(state.linePaging, 'totalEntries', totalEntries)
  },
  setLinePagingTotalPages(state, totalPages) {
    Vue.set(state.linePaging, 'totalPages', totalPages)
  },
  /* 機場預約 */
  setAirportList(state, list) {
    Vue.set(state, 'airportList', list)
  },
  setAirportPagingCurrentPage(state, currentPage) {
    Vue.set(state.airportPaging, 'currentPage', currentPage)
  },
  setAirportPagingNpp(state, npp) {
    Vue.set(state.airportPaging, 'npp', npp)
  },
  setAirportPagingTotalEntries(state, totalEntries) {
    Vue.set(state.airportPaging, 'totalEntries', totalEntries)
  },
  setAirportPagingTotalPages(state, totalPages) {
    Vue.set(state.airportPaging, 'totalPages', totalPages)
  },
  /* 訂單詳細資訊modal */
  setModalId(state, modalId) {
    Vue.set(state, 'modalId', modalId)
  },
  setModalDetail(state, modal) {
    Vue.set(state, 'modal', modal)
  },
}



// WEBPACK FOOTER //
// ./src/store/reservation/mutations.js